import { createContext, useContext, type ReactNode } from 'react';
import type { AdminApi } from './api.js';

const AdminApiContext = createContext<AdminApi | undefined>(undefined);

export function AdminApiProvider({
  api,
  children,
}: {
  api: AdminApi;
  children: ReactNode;
}) {
  return (
    <AdminApiContext.Provider value={api}>{children}</AdminApiContext.Provider>
  );
}

export function useAdminApi(): AdminApi {
  const api = useContext(AdminApiContext);
  if (!api) throw new Error('Admin API context is not available');
  return api;
}
